export const APP_NAME = 'mercury';
